import React from "react";
import "./index.scss";
import { Redirect } from "react-router-dom";
import Api from "../../services/api";
import { Diversos } from "../../services/diversos";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { ApplicationState } from "../../store";
import { Param } from "../../store/ducks/param/types";
import { Cart as CartRedux } from "../../store/ducks/cart/types";
import { User } from "../../store/ducks/user/types";
import * as UserActions from "../../store/ducks/user/actions";
import * as ParamActions from "../../store/ducks/param/actions";
import Cart from "../Cart";
import MultilevelSidebar from "react-multilevel-sidebar";
import "react-multilevel-sidebar/src/Sidebar.css";

// Import de Icones
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faUserCircle,
  faThLarge,
  faShoppingCart,
  faChevronDown,
  faBars,
  faSearch,
  faDrumstickBite,
} from "@fortawesome/free-solid-svg-icons";
// import { faInstagram, faFacebookSquare, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
// import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

// Import de Imagens
import logo from "../../assets/Images/logo.png";
import logoVermelha from "../../assets/Images/logo-vermelha.png";

// Import de Componentes Bootstrap
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";

declare var window;

interface StateProps {
  user: User;
  param: Param;
  cart: CartRedux;
}

interface OwnProps {
  searchTermo?: string;
  tipo?: number;
}

interface DispatchProps {
  doLogin(user: User): void;
  setParam(param: Param): void;
}

type Props = StateProps & DispatchProps & OwnProps;

class Header extends React.Component<Props> {
  api: any = null;
  state: any = null;
  searchbarRef: any;
  listener: any;

  constructor(props) {
    super(props);
    this.api = new Api();
    this.searchbarRef = React.createRef();
    this.listener = null;
    this.state = {
      isLoading: false,
      menu: null,
      searchTerm: this.props.searchTermo ? this.props.searchTermo : null,
      searchbarHasError: false,
      redirect: null,
      sidebarOpened: false,
      headerStatus: "top",
      inputOnFocus: false,
      options: [
        {
          title: "Navegação",
          content: [
            {
              id: 1,
              name: "Departamentos",
              children: [{ content: [] }],
            },
            { id: 2, name: "Promoções" },
            { id: 3, name: "Ofertas do mês" },
            { id: 4, name: "Solicitar Orçamento" },
          ],
        },
        {
          title: "SAC",
          content: [
            {
              id: 5,
              name: "Minha conta",
              children: [
                {
                  content: [
                    { id: 51, name: "Meus pedidos", to: "/" },
                    { id: 52, name: "Dados da conta", to: "/cadastro" },
                    { id: 53, name: "Trocar senha", to: "/nova_senha" },
                  ],
                },
              ],
            },
            { id: 6, name: "Receitas", to: "/receitas" },
            { id: 7, name: "Dicas", to: "/dicas" },
            { id: 8, name: "Fale conosco", to: "/contato" },
            { id: 9, name: "Nossas lojas", to: "/" },
            { id: 10, name: "Blog", to: "/" },
            { id: 11, name: "Domakoski", to: "/sobre-nos" },
          ],
        },
        // {
        //   content: [
        //     { id: 10, icon: <FontAwesomeIcon icon={faFacebookSquare}/>, to: "https://www.facebook.com/lojashidrocolombo/?ref=br_rs" },
        //     { id: 11, icon: <FontAwesomeIcon icon={faInstagram}/>, to: "https://www.instagram.com/lojashidrocolombo/?hl=pt-br" }
        //   ]
        // }
      ],
    };

    this.handleFocus = this.handleFocus.bind(this);
  }

  //   you can also use this function on any of your event to open/close the sidebar
  handleSidebarToggle = (isOpen) => {
    this.setState({ sidebarOpened: isOpen });
  };

  handleClick = (itemOptions) => {
    /* 
        do something with the item you clicked.
        you can also send custom properties of your choice
        in the options array you'll be getting those here
        whenever you click that item
    */
  };

  async componentDidMount() {
    const self = this;

    self.setState({ isLoading: true });

    try {
      const { data } = await self.api.get("/menu/nivel1");

      if (data.status === false) {
        throw new Error("Nao foi possível recuperar menu");
      } else {
        let aux: any = [];
        let aux2: any = [];

        for (var i = 0; i < data.msg.length; i++) {
          aux.push({
            codigo: data.msg[i].CDMENU,
            descricao: data.msg[i].DESCRICAO,
            menu2: data.msg[i].menu2,
          });

          aux2.push({
            id: i,
            name: Diversos.capitalize(data.msg[i].DESCRICAO),
            to: "/departamento/" + Diversos.toSeoUrl(data.msg[i].DESCRICAO),
          });
        }

        let tmp = self.state.options;
        tmp[0].content[0].children[0].content = aux2;

        self.setState({ menu: aux, options: tmp });
      }
    } catch (e) {
      console.error(e);
      self.setState({ menu: null });
    } finally {
      self.setState({ isLoading: false });
    }

    if (window.pageYOffset >= 150) {
      this.setState({ headerStatus: "" });
    }

    this.listener = document.addEventListener("scroll", (e) => {
      if (document.scrollingElement === null) {
        alert("scrollingElement é null");
      } else {
        var scrolled = document.scrollingElement.scrollTop;
        if (scrolled >= 110) {
          if (this.state.headerStatus !== "") {
            this.setState({ headerStatus: "" });
          }
        } else {
          if (this.state.headerStatus !== "top") {
            this.setState({ headerStatus: "top" });
          }
        }
      }
    });
  }

  componentDidUpdate() {
    document.removeEventListener("scroll", this.listener);
  }

  handleFocus() {
    // const self = this;
    this.setState({
      inputOnFocus: !this.state.inputOnFocus,
    });
    return true;
  }

  private getCartAmount() {
    const self = this;
    let amount = 0;
    for (var i = 0; i < self.props.cart.produtos.length; i++) {
      amount += self.props.cart.produtos[i].qty;
    }
    return amount;
  }

  /**
   * FAZ TRATAMENTO DO BOTAO DE PESQUISA
   */
  private async handleSearch() {
    const self = this;
    if (!self.state.searchTerm) {
      self.searchbarRef.current.focus();
      self.setState({ searchbarHasError: true });
    } else {
      self.setState({
        redirect: `/busca/${Diversos.toSeoUrl(self.state.searchTerm)}`,
      });
      window.location.href = `/busca/${Diversos.toSeoUrl(
        self.state.searchTerm
      )}`;
    }
  }

  headerType() {
    if (window.location.pathname === "/" && this.state.headerStatus === "top") {
      return "transparent-header";
    }

    return "filled-header";
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    const transparentHeader =
      window.location.pathname === "/" && this.state.headerStatus === "top";

    return (
      <>
        {!this.props.tipo || this.props.tipo !== 2 ? (
          <>
            <header className={this.headerType()}>
              <Container fluid className="header-full">
                <Row>
                  <Col xs={12} sm={8} lg={5} className="w-75 search-col">
                    <InputGroup
                      className={`search-box-container ${
                        this.state.inputOnFocus ? " searchbar-focus" : ""
                      }`}
                    >
                      <InputGroup.Prepend>
                        <InputGroup.Text
                          id="lupa-pesquisa"
                          className="text-input-addon"
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </InputGroup.Text>
                      </InputGroup.Prepend>
                      <FormControl
                        className={`search-box-input ${
                          transparentHeader ? "" : "dark-text"
                        }`}
                        placeholder="O que está procurando?"
                        onChange={(event) =>
                          this.setState({ searchTerm: event.target.value })
                        }
                        onFocus={this.handleFocus}
                        onBlur={this.handleFocus}
                        onKeyPress={(event) =>
                          event.key === "Enter" && this.handleSearch()
                        }
                        aria-label="Busca"
                        aria-describedby="lupa-pesquisa"
                      />
                      <InputGroup.Prepend>
                        <Button className="btn-primary-action"> Buscar </Button>
                      </InputGroup.Prepend>
                    </InputGroup>
                  </Col>
                  <Col xs={4} lg={2} className="d-none d-sm-flex logo-col">
                    <div
                      className="logo-container"
                      style={{ marginTop: transparentHeader ? "10px" : "20px" }}
                    >
                      <a href="/">
                        <img
                          src={transparentHeader ? logo : logoVermelha}
                          style={{ width: transparentHeader ? "100%" : "90%" }}
                          alt="logo Domakoski"
                        />
                      </a>
                    </div>
                  </Col>
                  <Col xs={4} sm={4} className="d-lg-none burger-menu">
                    <span
                      className="user-link"
                      onClick={() => this.handleSidebarToggle(true)}
                    >
                      <FontAwesomeIcon icon={faBars} className="header-icon" />
                    </span>
                  </Col>

                  {/* Logo para o menu mobile, telas > sm */}
                  <Col xs={4} lg={2} className="d-flex d-sm-none logo-col">
                    <div
                      className="logo-container"
                      // style={{marginTop: this.state.headerStatus === "top" ? "10px" : "20px"}}
                    >
                      <a href="/">
                        <img
                          src={transparentHeader ? logo : logoVermelha}
                          style={{ width: transparentHeader ? "100%" : "90%" }}
                          alt="logo Domakoski"
                        />
                      </a>
                    </div>
                  </Col>
                  <Col xs={4} sm={8} lg={5} className="user-links">
                    <a
                      className="user-link d-none d-sm-flex"
                      href={
                        this.props.user && this.props.user.status === true
                          ? "/meus-pedidos"
                          : "/login"
                      }
                      target="_self"
                      title="Meus pedidos"
                    >
                      <FontAwesomeIcon
                        icon={faDrumstickBite}
                        className="header-icon"
                      />
                      Meus pedidos
                    </a>
                    <a
                      className="user-link d-none d-sm-flex"
                      href={
                        this.props.user && this.props.user.status === true
                          ? "/meu-cadastro"
                          : "/login"
                      }
                      target="_self"
                      title={
                        this.props.user && this.props.user.status === true
                          ? "Meu cadastro"
                          : "Fazer login"
                      }
                    >
                      <FontAwesomeIcon icon={faUser} className="header-icon" />
                      {this.props.user && this.props.user.status === true
                        ? "Meu perfil"
                        : "Cadastre-se ou faça Login"}
                    </a>
                    <span
                      className="user-link header-cart"
                      onClick={() =>
                        this.props.setParam({
                          ...this.props.param,
                          cartOpened: true,
                        })
                      }
                    >
                      <FontAwesomeIcon
                        icon={faShoppingCart}
                        className="header-icon"
                      />
                      <Badge
                        pill
                        className={`header-cart-summary ${
                          transparentHeader ? "badge-top" : ""
                        }`}
                      >
                        {" "}
                        {this.getCartAmount() || 0}{" "}
                      </Badge>
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col className="d-none d-lg-block">
                    <nav
                      className="nav-container"
                      style={{
                        borderWidth: transparentHeader ? "2px" : "",
                        borderStyle: transparentHeader ? "solid" : "",
                        borderColor: transparentHeader
                          ? "map-get($colors, ultraLight)"
                          : "",
                        marginTop: transparentHeader ? "1.1rem" : "0",
                      }}
                    >
                      <ul className="nav-bar">
                        <li>
                          <FontAwesomeIcon
                            icon={faThLarge}
                            className="categories-icon"
                            style={{
                              height: transparentHeader ? "40px" : "50px",
                            }}
                          />
                          Categorias
                          <FontAwesomeIcon icon={faChevronDown} />
                          {this.state.isLoading ? (
                            <ul
                              className="dropdown-lvl-one"
                              style={{
                                top: transparentHeader ? "60px" : "50px",
                              }}
                            >
                              <li>
                                {" "}
                                <FontAwesomeIcon icon="spinner" spin />{" "}
                              </li>
                            </ul>
                          ) : this.state.menu && this.state.menu.length > 0 ? (
                            <ul
                              className="dropdown-lvl-one"
                              style={{
                                top: transparentHeader ? "60px" : "50px",
                              }}
                            >
                              {this.state.menu.map((row, index) => (
                                <li key={index}>
                                  <a
                                    href={`/departamento/${Diversos.toSeoUrl(
                                      row.descricao
                                    )}`}
                                    target="_self"
                                  >
                                    {Diversos.capitalize(row.descricao)}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          ) : null}
                        </li>

                        {this.state.menu && this.state.menu.length > 0
                          ? this.state.menu.map((row, index) => (
                              <li key={index}>
                                <a
                                  href={`/departamento/${Diversos.toSeoUrl(
                                    row.descricao
                                  )}`}
                                  target="_self"
                                >
                                  {Diversos.capitalize(row.descricao)}
                                </a>
                              </li>
                            ))
                          : null}

                        <li>
                          {" "}
                          <a href={`/sobre-nos`} target="_self">
                            Domakoski
                          </a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a href={`/receitas`} target="_self">
                            Receitas
                          </a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a href={`/dicas`} target="_self">
                            Dicas
                          </a>{" "}
                        </li>
                        <li>
                          {" "}
                          <a href={`/contato`} target="_self">
                            Contato
                          </a>{" "}
                        </li>
                      </ul>
                    </nav>
                  </Col>
                </Row>
              </Container>
            </header>
          </>
        ) : (
          <>
            <header className="checkout-header">
              <a href="/" title="Voltar para a Home" tabIndex={0}>
                {" "}
                <img src={logoVermelha} className="" alt="logo" />{" "}
              </a>
            </header>
          </>
        )}

        <Modal
          show={this.props.param.cartOpened}
          onHide={() =>
            this.props.setParam({ ...this.props.param, cartOpened: false })
          }
          dialogClassName="cart-container"
          className="px-0"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Cart />
        </Modal>
        <MultilevelSidebar
          open={this.state.sidebarOpened}
          onToggle={this.handleSidebarToggle}
          options={this.state.options}
          onItemClick={this.handleClick}
          wrapperClassName="sidebar-mobile-menu"
          header={
            <>
              <Container className="sidebar-header">
                <a
                  className="sidebar-user-link"
                  href={
                    this.props.user && this.props.user.status === true
                      ? "/cadastro"
                      : "/login"
                  }
                  target="_self"
                  title={
                    this.props.user && this.props.user.status === true
                      ? "Meu cadastro"
                      : "Fazer login"
                  }
                >
                  <FontAwesomeIcon
                    icon={faUserCircle}
                    className="sidebar-user-icon"
                  ></FontAwesomeIcon>
                  <span className="sidebar-user-action">
                    <span className="sidebar-user-title"> Meu perfil </span>
                    {this.props.user && this.props.user.status === true ? (
                      <span> Meu cadastro </span>
                    ) : (
                      <span> Cadastre-se ou faça login </span>
                    )}
                  </span>
                </a>
              </Container>
            </>
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.data,
  param: state.param.data,
  cart: state.cart.data,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ ...UserActions, ...ParamActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Header);
